
import customSelect from 'custom-select';

const customSelectHelper = (selector) => {
  const customSelects = customSelect(selector, {
    containerClass: 'custom-select-v2',
    openerClass: 'custom-select-v2__opener',
    panelClass: 'custom-select-v2__panel',
    optionClass: 'custom-select-v2__option',
    optgroupClass: 'custom-select-v2__optgroup',
    isSelectedClass: 'is-selected',
    hasFocusClass: 'has-focus',
    isDisabledClass: 'is-disabled',
    isOpenClass: 'is-open'
  });

  // Apply css classes from select element to the customSelect element
  customSelects.forEach(sel => {
    let cssClasses = sel.select.classList.toString().split(' ');
    cssClasses.forEach(cssClass => {
      if(cssClass && cssClass.indexOf('js-') !== 0){ // Exclude js classes
        sel.container.classList.add(cssClass);
      }
    })
  });

  return customSelects;
}

export default customSelectHelper;
